<template>
    <div class="file-preview" :class="type" @click="show()">

        <template v-if="file">
            <img v-if="preview" class="preview-image" :src="preview_url_thumb" :alt="file?.name">
            <div class="name" v-if="showName">{{ file.name }}</div>
        </template>

        <button v-if="showDelete"
                class="btn btn-danger"
                @click.stop.prevent="remove()">&times;</button>


        <modal :id="utils.randomId({prefix: 'modal'})"
               v-if="show_modal"
               size="xl"
               :show="true"
               @close="hide()"
               @click.prevent.stop>
            <template #title v-if="title">{{ title === true ? file.name : title }}</template>
            <div class="modal-body">
                <template v-if="is_video">
                    <video :src="uploads.url(file.url)"
                           class="preview-video"
                           autoplay
                           controls/>
                </template>
                <template v-else>
                    <img class="modal-preview" :src="preview_url_large" alt="">
                </template>
            </div>
        </modal>

    </div>
</template>

<script>
import uploads from "@/mixins/uploads";
import Modal from "@/Components/Common/Modal";
import utils from "@/mixins/utils";

export default {
    name: "FilePreview",
    components: {Modal},
    mixins: [uploads, utils],

    emits: ['delete'],

    props: {
        file: {
            type: Object,
            default: () => null,
        },
        preview: {
            type: [Object, Boolean],
            default: () => ({w: 240, h: 240, c: true}),
        },
        showName: {
            type: Boolean,
            default: true,
        },
        showDelete: {
            type: Boolean,
            default: false,
        },
        title: {
            type: [Boolean,String],
            default: true,
        },
        type: {
            type: [String],
            default: '',
        }
    },

    data(){
        return {
            show_modal: false,
        };
    },

    computed: {

        preview_options(){
            if( this.preview === true ){
                return {w: 240, h: 240, c: true}
            }
            return this.preview;
        },

        is_video() {
            switch (this.file?.mime){
                case 'video/mp4':
                case 'video/avi':
                case 'video/mov':
                    return true;
            }
            return false;
        },

        preview_url(){
            switch (this.file?.mime){
                case 'image/jpeg':
                case 'image/jpg':
                case 'image/png':
                case 'image/gif':
                case 'application/pdf':
                    return this.file?.preview_url ? this.file.preview_url : this.file?.url;

                default:
                    return this.file?.preview_url ? this.file.preview_url : null;
            }
        },

        preview_url_thumb(){
            if( this.preview ){
                return this.uploads.image( this.preview_url, this.preview_options );
            }
            return this.preview_url;
        },

        preview_url_large(){
            return this.uploads.image( this.preview_url, {w: 1200, h: 1200, c: false});
        },
    },

    methods: {
        remove(){
            if( !confirm('Are you sure to remove this file?') ) return;
            this.$emit('delete', this.file);
        },

        show(){
            this.show_modal = true;
        },

        hide(){
            this.show_modal = false;
        },

    }

}
</script>

<style lang="scss" scoped>
.file-preview{
    border: $light solid 2px;
    box-shadow: rgba(black, 0.1) 0 3px 3px;
    border-radius: 0.5rem;
    position: relative;
    cursor: pointer;
    height: 100%;
    user-select: none;

    &.list{
        display: flex;
        align-items: center;
        box-shadow: none;
        border: none;

        &:hover{
            .btn-danger{
                opacity: 1;
            }
        }

        .preview-image{
            width: 50%;
            height: auto;
            background: none;
            box-shadow: rgba(black, .1) 0 1px 3px;
            @media (max-width: 1200px) {
                width: 100%;
            }
        }

        .name{
            background: none;
            flex-grow: 1;
        }

        // .btn-danger{
        //     position: relative;
        //     flex-shrink: 0;
        //     flex-grow: 0;
        //     opacity: 0;
        //     top: -3px;
        // }
    }

    flex-grow: 1;
    padding: .6rem;
    gap: 1rem;

    @media (max-width: 1200px) {
        flex-direction: column;
    }
}
.preview-video{
    width: 100%;
    height: 70vh;
}
.preview-image{
    border-radius: 0.5rem;
    flex-shrink: 0;
    display: block;
    width: 100%;
}
.name{
    padding: 0.3rem;
    background: $light;
    word-break: break-word;
}

.btn-danger{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    transform: translate(-15%, 15%);
    font-size: 1.4rem;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    line-height: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
}

.modal-body{
    max-height: 75vh;
    display: flex;
}

.modal-preview{
    width: 100%;
    object-fit: contain;
}
</style>
